import { FILE_TYPE } from '@constants/FileType';
import { Content, MinifiedContent } from '@models/content/Content';

export const getExtensionUrl = (url: string): string => {
	let extension = 'epub';
	const searchEpub = 'https://bc.vitalsource.com/';
	const isEpub = url.indexOf(searchEpub) !== -1;
	const isVideo = url.indexOf('http') === -1; // URL VIDEO ONLY STRING ID
	if (!isEpub && !isVideo) {
		let filename = url.substring(url.lastIndexOf('/') + 1);
		filename = filename.split('?')[0];
		extension = filename.split('.')[1].replace('%22', '');
	} else if (isVideo) {
		extension = 'mp4';
	}

	return extension;
};

export const getTypeFileIdByExtension = (extension: string) => {
	switch (extension) {
		case 'mp3':
			return FILE_TYPE.audios;
		case 'pdf':
			return FILE_TYPE.documents;
		case 'mp4':
			return FILE_TYPE.videos;
		case 'xlsx':
		case 'xls':
		case 'xlsm':
		case 'docx':
		case 'doc':
		case 'docm':
		case 'pptx':
		case 'pptm':
		case 'ppt':
			return FILE_TYPE.interactive;
		case 'epub':
			return FILE_TYPE.digitalTextBooks;
		default:
			return FILE_TYPE.videos;
	}
};

export const getFileTypeByContent = (content: Content) => {
	const { urlContent, name } = content;
	if (urlContent.includes('https://bc.vitalsource.com/')) {
		return FILE_TYPE.digitalTextBooks;
	} else if (name.includes('Guía') || name.includes('Guía ') || name.includes('Guia')) {
		return FILE_TYPE.guides;
	} else if (name.includes('Audio')) {
		return FILE_TYPE.audios;
	} else if (name.includes('Imprimible')) {
		return FILE_TYPE.documents;
	} else if (name.includes('Libro de Texto')) {
		return FILE_TYPE.textBooks;
	} else if (name.includes('Interactivo')) {
		return FILE_TYPE.interactive;
	} else if (name.includes('Presentación')) {
		return FILE_TYPE.presentacionesWebinar;
	} else if (name.includes('Cuadernillo')) {
		return FILE_TYPE.cuadernillos;
	} else if (name.toLocaleLowerCase().includes('baldor')) {
		return FILE_TYPE.baldor;
	} else if (name.toLocaleLowerCase().includes('nem')) {
		return FILE_TYPE.nuevaEscuelaMexicana;
	} else if (name.toLocaleLowerCase().includes('solucionario')) {
		return FILE_TYPE.solucionarios;
	} else if (content.fileTypeId == 30) {
		return FILE_TYPE.novedades;
	} else if (name.toLocaleLowerCase().includes('cartel')) {
		return FILE_TYPE.posters;
	}

	return FILE_TYPE.videos;
};

export const getFileTypeByContents = (content: MinifiedContent) => {
	const { urlContent, name } = content;
	if (urlContent.includes('https://bc.vitalsource.com/')) {
		return FILE_TYPE.digitalTextBooks;
	} else if (name.includes('Guía') || name.includes('Guía ') || name.includes('Guia')) {
		return FILE_TYPE.guides;
	} else if (name.includes('Audio')) {
		return FILE_TYPE.audios;
	} else if (name.includes('Imprimible')) {
		return FILE_TYPE.documents;
	} else if (name.includes('Libro de Texto')) {
		return FILE_TYPE.textBooks;
	} else if (name.includes('Interactivo')) {
		return FILE_TYPE.interactive;
	} else if (name.includes('Presentación')) {
		return FILE_TYPE.presentacionesWebinar;
	} else if (name.includes('Cuadernillo')) {
		return FILE_TYPE.cuadernillos;
	} else if (name.toLocaleLowerCase().includes('baldor')) {
		return FILE_TYPE.baldor;
	} else if (name.toLocaleLowerCase().includes('nem')) {
		return FILE_TYPE.nuevaEscuelaMexicana;
	} else if (name.toLocaleLowerCase().includes('solucionario')) {
		return FILE_TYPE.solucionarios;
	} else if (content.fileTypeId == 30) {
		return FILE_TYPE.novedades;
	} else if (name.toLocaleLowerCase().includes('cartel')) {
		return FILE_TYPE.posters;
	}

	return FILE_TYPE.videos;
};

export const getFileTypeByUrl = (fullUrl: string) => {
	try {
		const url = new URL(fullUrl);
		const extension = getExtensionUrl(url.href);
		return getTypeFileIdByExtension(extension);
	} catch {
		return FILE_TYPE.videos;
	}
};
